// extracted by mini-css-extract-plugin
module.exports = {"paper":"ResetPasswordForm_paper__2UCas","button":"ResetPasswordForm_button__35PoZ","message":"ResetPasswordForm_message__1vAyq"};